import axios from "axios";
import type { AxiosError, AxiosInstance, CreateAxiosDefaults } from "axios";
import https from "https";

import appConfigs from "@/configs";
import { decryptData, encryptData } from "../helpers/cryptor";
import { redirect } from "../helpers";

function createHttpClient(configs: CreateAxiosDefaults): AxiosInstance {
  const httpClient = axios.create(configs);
  httpClient.interceptors.request.use(
    async (value) => {
      const encryptedRequest = await encryptData(value);

      return encryptedRequest;
    },
    (error: unknown) => {
      return error;
    }
  );

  httpClient.interceptors.response.use(
    async (response) => {
      const decryptedResponse = await decryptData(response);

      return decryptedResponse;
    },
    async (error: AxiosError) => {
      const errorResponse = error?.response;

      if (errorResponse && errorResponse?.status === 401) {
        redirect({ target: "/login" });

        throw error;
      }

      const decryptedErrorResponse = await decryptData(errorResponse);

      throw decryptedErrorResponse;
    }
  );

  return httpClient;
}

/**
 ** === HTTP CLIENTS
 * =================================================================================
 */

const httpClient = createHttpClient({
  baseURL: appConfigs.api.baseURL,
  maxContentLength: Infinity,
  withCredentials: true,
  httpsAgent: new https.Agent({
    rejectUnauthorized: false,
  }),
  maxBodyLength: Infinity,
  headers: {
    "x-Nexus-Channel-Name": "CorporateWeb",
    "x-Nexus-App-Name": "uption",
    "x-Nexus-App-Version": appConfigs.version,
    "x-Nexus-Channel-Type": "Web",
    "x-Nexus-subscription-key": appConfigs.api.subscriptionKey,
  },
});

export default httpClient;
